import { IBidDescription } from 'types/bidDescription'
import { IModificationInfo } from 'types/creationDetails'

export enum EBidProcurementMeasurement {
  KILOGRAM = 'KILOGRAM',
  GRAM = 'GRAM',
  KILOMETER = 'KILOMETER',
  METER = 'METER',
  CENTIMETER = 'CENTIMETER',
  DECIMETER = 'DECIMETER',
  MILLIMETER = 'MILLIMETER',
  HECTARE = 'HECTARE',
  ARE = 'ARE',
  M3 = 'M3',
  M2 = 'M2',
  BOX = 'BOX',
  TON = 'TON',
  PACKAGE = 'PACKAGE',
  LITRE = 'LITRE',
  ITEM = 'ITEM',
  MONTH = 'MONTH',
  DAY = 'DAY',
  YEAR = 'YEAR',
}

export interface IBidProcurementItem extends IModificationInfo {
  id: string
  order: number
  name: string
  quantity: number
  description: string
  measurement: EBidProcurementMeasurement
  bidDescription: IBidDescription
}
